import {Component, OnInit} from '@angular/core';
import {AuthorityChannelingService, User, UserGroup} from '../../../authority-shared/services/authority-channeling.service';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MatDialogRef} from '@angular/material/dialog';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-authority-forced-channeling-dialog',
	templateUrl: './authority-forced-channeling-dialog.component.html',
	styleUrls: ['./authority-forced-channeling-dialog.component.scss']
})
export class AuthorityForcedChannelingDialogComponent implements OnInit {

	userGroups: UserGroup[];
	groupControl: FormControl = new FormControl();
	usersControl: FormControl = new FormControl();
	groupFilteredOptions: Observable<UserGroup[]>;
	usersFilteredOptions: Observable<User[]>;
	currentGroup: UserGroup;
	users: User[];
	currentUser: User;
	showModal: boolean = false;
	translateContext: TranslateContext = TranslateContext.AUTHORITY;

	constructor(private authorityChannelingService: AuthorityChannelingService,
				private messageManagerService: MessageManagerService,
				private environment: AppConfigEnvironmentService,
				private dialogRef: MatDialogRef<AuthorityForcedChannelingDialogComponent>) {
	}


	ngOnInit(): void {
		this.usersControl.disable();

		this.authorityChannelingService.getUsersGroup().subscribe(response => {
			this.userGroups = response;
			this.showModal = true;
			this.usersControl.disable();
			this.groupFilteredOptions = this.groupControl.valueChanges.pipe(
				startWith(''),
				map(group => group ? this._filterUserGroups(group) : this.userGroups));
		}, error => this.messageManagerService.pushInnerMessage({...MessageManagerUtilities.getMessageDetailsFromResponse(error), ...{isTop: false}}));

		this.groupControl.valueChanges.subscribe(value => {
			if (value === '') {
				this.usersControl.setValue(null);
				this.usersControl.disable();
				this.currentUser = null;
			} else {
				this.usersControl.enable();
			}
		});
	}

	get disabled(): boolean {
		return !this.currentGroup && !this.currentUser;
	}

	private _filterUserGroups(value: string): UserGroup[] {
		if (value) {
			return this.userGroups.filter(option => option.user_group.toLowerCase().includes(value));
		}
		return this.userGroups;
	}

	private _filterUsers(value: string): User[] {
		if (value) {
			return this.users.filter(option => option.email.toLowerCase().includes(value));
		}
		return this.users;
	}

	userGroupsDisplayFn(userGroup: UserGroup): string {
		if (!!userGroup) {
			return userGroup.user_group;
		}
	}

	usersDisplayFn(user: User): string {
		if (!!user) {
			return user.email;
		}
	}

	selectGroup(selected: boolean, option: UserGroup): void {
		if (option !== this.currentGroup) {
			this.usersControl.setValue(null);
			this.usersControl.disable();
			this.currentUser = null;
			this.showModal = false;
			this.getUsersByGroupId(option);
		} else {
			this.usersControl.enable();
		}
		this.currentGroup = option;
	}

	getUsersByGroupId(selectedGroup: UserGroup): void {
		this.authorityChannelingService.getUsersByGroups(selectedGroup.id).subscribe(response => {
			this.users = response;
			this.usersControl.enable();
			this.showModal = true;
			this.usersFilteredOptions = this.usersControl.valueChanges.pipe(
				startWith(''),
				map(user => user ? this._filterUsers(user) : this.users)
			);
		}, error => this.messageManagerService.pushInnerMessage({...MessageManagerUtilities.getMessageDetailsFromResponse(error), ...{isTop: false}}));
	}

	selectUser(selected: boolean, option: User): void {
		this.currentUser = option;
	}

	closeDialog(hasBeClosed?: boolean): void {
		hasBeClosed ?
			this.dialogRef.close(null) :
			this.dialogRef.close({
				group: this.currentGroup,
				user: this.currentUser
			});
	}
}
